import { useLocation, useNavigate } from 'react-router-dom';
import { NotAuthenticatedError } from '../../api';
import { useAuth } from '../useAuth';
import { useAccount } from './account';
import { useEffect } from 'react';

/**
 * Custom hook to fetch account data with authentication guard.
 * If the user is not authenticated, it redirects to the login page.
 */
export function useAccountWithGuard() {
  const { setToken } = useAuth();
  const { data, error, isLoading } = useAccount();
  const nav = useNavigate();
  const loc = useLocation();

  useEffect(() => {
    if (error instanceof NotAuthenticatedError) {
      setToken('');
      localStorage.removeItem('id_token');
      nav(`/login?next=${loc.pathname}`);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [error, loc.pathname]);

  return {
    data,
    error,
    isLoading,
  };
}
